const createDatePad = (date) => Math.floor(date / (1000 * 60 * 60 * 24));

const defaultSlice = () => ({
  duration: 0,
  viewed: 0,
  low: 0,
  high: 0
});

const createDaySlices = (days = 30) => {
  const result = {};
  const now = new Date();

  for (let i = days; i > 0; i--) {
    const date = new Date(now);
    date.setDate(now.getDate() - i);

    const pad = createDatePad(date.getTime());
    result[pad] = defaultSlice();
  }

  return result;
};

export const updateTimelineData = (data) => {
  const slices = createDaySlices(30);

  let durationTotal = 0;
  let viewedTotal = 0;

  data.forEach((item) => {
    const timestamp = new Date(item.utcts).getTime();
    const date = createDatePad(timestamp);

    slices[date] = slices[date] || defaultSlice();

    if (item.objecttype === 'videoactivity') {
      slices[date].viewed++;
      viewedTotal++;

      const watchDifference = item.note.end - item.note.start;
      slices[date].duration += watchDifference;
      durationTotal += watchDifference;

      slices[date].low = item.note.start;
      slices[date].high = item.note.end;
    }
  });

  const mapSeries = (key) => {
    return Object.entries(slices).map(([date, config]) => {
      const timestamp = new Date(date * 1000 * 60 * 60 * 24).getTime();

      return [timestamp, config[key]];
    });
  };

  return {
    viewedSeries: mapSeries('viewed'),
    viewedTotal,
    durationSeries: mapSeries('duration').map(([ts, duration]) => [ts, duration.toFixed(0)]),
    avgDuration: viewedTotal ? durationTotal / viewedTotal : 0,
    lowSeries: mapSeries('low'),
    highSeries: mapSeries('high')
  };
};
